(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pb-going-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-going-home')) {
    customElements.define('pb-going-home', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        this.querySelector('.pb-home__controls').hidden = false;
        this.selectMood('introvert');
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-pb-mood]');
          if (button && this.contains(button)) this.selectMood(button.dataset.pbMood);
        });
      }
      selectMood(mood) {
        this.querySelectorAll('[data-pb-mood]').forEach(button => {
          const selected = button.dataset.pbMood === mood;
          button.setAttribute('aria-pressed', String(selected));
          button.classList.toggle('btn--solid', selected);
          button.classList.toggle('btn--outline', !selected);
        });
        this.querySelectorAll('[data-pb-panel]').forEach(panel => { panel.hidden = panel.dataset.pbPanel !== mood; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-scent-relationships"]) return;
  try {
    
document.addEventListener('click',(event)=>{const card=event.target.closest('[data-pb-scent-related-card]');if(!card||event.target.closest('a, button, input, select, textarea'))return;window.location.href=card.dataset.href;});

  } catch(e) { console.error(e); }
})();
})();
